import { Entry } from 'contentful'
import {
  IContentfulConfigurableSlider,
  IContentfulConfigurableSliderEntry,
} from 'types/contentful/configurableSlider.types'
import { parseConfigurableTile } from './parseConfigurableTile'
import { parseConfigurableCard } from './parseConfigurableCard'

const parseSlide = (slide) => {
  if (!slide) {
    return null
  }

  const contentType = slide.sys?.contentType?.sys?.id

  if (contentType === 'configurableCard') {
    return parseConfigurableCard(slide)
  }

  if (contentType === 'configurableTile') {
    return parseConfigurableTile(slide)
  }

  return null
}

export const parseConfigurableSlider = (
  configurableCard: Entry<IContentfulConfigurableSliderEntry>
): IContentfulConfigurableSlider => {
  const slider = {
    componentKey: 'configurableSlider',
    name: configurableCard?.fields?.name,
    isShowArrows: configurableCard?.fields?.isShowArrows,
    loop: configurableCard?.fields?.loop,
    autoSwitchSpeed: configurableCard?.fields?.autoSwitchSpeed,
    indicator: configurableCard?.fields?.indicator,
    tilesInViewDesktop: configurableCard?.fields?.tilesInViewDesktop,
    tilesInViewTablet: configurableCard?.fields?.tilesInViewTablet,
    tilesInViewMobile: configurableCard?.fields?.tilesInViewMobile,
    slides: configurableCard?.fields?.slides
      ?.map((slide) => parseSlide(slide))
      ?.filter(Boolean),
    trackingIdentifier: configurableCard?.fields?.trackingIdentifier,
  }
  return slider
}
